import classNames from 'classnames';

import ArrowRightIcon from '@/assets/icons/arrow-right.svg?react';
import buttonStyles from '@/shared/components/Button/index.module.scss';
import DynamicT from '@/shared/components/DynamicT';

import styles from './SsoSignInButton.module.scss';

type Props = {
  readonly onClick: () => void;
};

/**
 * TDA: single sign-on as the card's primary action.
 *
 * NEW FILE — upstream has no equivalent, so it costs nothing at merge time.
 *
 * ⚠️ Rendered ONLY when SSO is the sole way in (`pages/SignIn`). Upstream puts
 * SSO in the footer as a text link, which is right when there is a credential
 * form above it: two full-width primary buttons on one card give the eye no
 * first move, and the form's own submit is the one that belongs there. So this
 * replaces the link rather than joining it.
 *
 * ⚠️ Composed from `shared/components/Button`'s module instead of using the
 * component. That `Button` positions its `icon` absolutely at the INLINE START —
 * a leading icon — and the mock's arrow is trailing and slides on hover. The
 * same idiom as `PasskeySignInButton`, which borrows those classes for the same
 * reason.
 */
const SsoSignInButton = ({ onClick }: Props) => (
  <button
    className={classNames(
      buttonStyles.button,
      buttonStyles.primary,
      buttonStyles.large,
      styles.button
    )}
    type="button"
    onClick={onClick}
  >
    <DynamicT forKey="action.single_sign_on" />
    <ArrowRightIcon className={styles.icon} />
  </button>
);

export default SsoSignInButton;
